import React, { Component } from "react";
import { MDBInput, MDBContainer, MDBBtn, MDBRow, MDBCol, MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { SearchBtnContainer, logs } from "./components.js";

class DeviceState extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logArray: [],
      searchBarInput: ''
    }
  }

  fetchLogs() {
    let query = this.state.searchBarInput
      ? `?_query=true&_fields=macAddress,serialNumber&_regExp=${this.state.searchBarInput}`
      : ""

    fetch(`${global.gConfig.backend.url}/api/v1/devicestatelog${query}`)
      .then(res=>res.json())
      .then(logs => {
        this.setState({logArray: logs})
      })
      .catch( err => err )
  }

  onSearchBarChange(e) { this.setState({searchBarInput: e.target.value}) }

  render() {
    const { logArray } = this.state;
    return(
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol>
            <MDBInput onChange={(e) => this.onSearchBarChange(e)} label="Searching by serial number or mac address" outline/>
          </MDBCol>
          <MDBCol size="2">
            <SearchBtnContainer>
              <MDBBtn onClick={() => {this.fetchLogs();}} size="md" className="w-100" rounded>Search</MDBBtn>
            </SearchBtnContainer>
          </MDBCol>
        </MDBRow>
        <MDBTable>
          <MDBTableHead color="primary-color" textWhite>
            <tr>
              <th>Created Time</th>
              <th>Mac Address</th>
              <th>Serial Number</th>
              <th>Previous State</th>
              <th>Next State</th>
              <th>Content</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            { this.state.logArray ? logs(logArray) : null}
          </MDBTableBody>
        </MDBTable>
      </MDBContainer>
    );
  }
}

export default DeviceState;
